import api from "@/helper/api";
import http from "@/helper/http";

const listFrom = (response) => {
  const body = response?.data;
  if (Array.isArray(body)) return body;
  for (const key of ["items", "data", "results", "operational_units", "operational_unit_types"]) {
    if (Array.isArray(body?.[key])) return body[key];
  }
  return [];
};

const resourceFrom = (response) =>
  response?.data?.data || response?.data?.item || response?.data;

const paramsWithoutEmptyValues = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== "" && value !== null && value !== undefined),
  );

export const getOperationalUnitTypes = async (storeId, params) =>
  listFrom(
    await http.get(api.operational_unit_types(storeId), {
      params: paramsWithoutEmptyValues(params),
    }),
  );

export const createOperationalUnitType = async (storeId, payload) =>
  resourceFrom(await http.post(api.operational_unit_types(storeId), payload));

export const updateOperationalUnitType = async (storeId, typeId, payload) =>
  resourceFrom(await http.patch(api.operational_unit_type(storeId, typeId), payload));

export const deleteOperationalUnitType = (storeId, typeId) =>
  http.delete(api.operational_unit_type(storeId, typeId));

export const getOperationalUnits = async (storeId, params) =>
  listFrom(
    await http.get(api.operational_units(storeId), {
      params: paramsWithoutEmptyValues(params),
    }),
  );

export const createOperationalUnit = async (storeId, payload) =>
  resourceFrom(await http.post(api.operational_units(storeId), payload));

export const updateOperationalUnit = async (storeId, unitId, payload) =>
  resourceFrom(await http.patch(api.operational_unit(storeId, unitId), payload));

export const deleteOperationalUnit = (storeId, unitId) =>
  http.delete(api.operational_unit(storeId, unitId));

export const getOperationalUnitAvailability = async (storeId, params) =>
  listFrom(
    await http.get(api.operational_unit_availability(storeId), {
      params: paramsWithoutEmptyValues(params),
    }),
  );

export const getOperationalUnitStatistics = async (storeId, params) =>
  resourceFrom(
    await http.get(api.operational_unit_statistics(storeId), {
      params: paramsWithoutEmptyValues(params),
    }),
  );

const assignmentEndpoints = {
  ticket: {
    assign: api.ticket_operational_unit,
    history: api.ticket_operational_unit_history,
  },
  "sale-cart": {
    assign: api.sale_cart_operational_unit,
    history: api.sale_cart_operational_unit_history,
  },
};

export const assignOperationalUnit = async (storeId, targetType, targetId, payload) => {
  const endpoint = assignmentEndpoints[targetType];
  if (!endpoint) throw new Error(`Unsupported assignment target: ${targetType}`);
  return resourceFrom(await http.post(endpoint.assign(storeId, targetId), payload));
};

export const correctSaleCartOperationalUnit = async (storeId, saleCartId, payload) =>
  resourceFrom(
    await http.post(api.sale_cart_operational_unit_correction(storeId, saleCartId), payload),
  );

export const getOperationalUnitAssignmentHistory = async (
  storeId,
  targetType,
  targetId,
) => {
  const endpoint = assignmentEndpoints[targetType];
  if (!endpoint) throw new Error(`Unsupported assignment target: ${targetType}`);
  return listFrom(await http.get(endpoint.history(storeId, targetId)));
};

export const releaseOperationalUnit = async (storeId, unitId, payload) =>
  resourceFrom(
    await http.post(api.operational_unit_release(storeId, unitId), payload),
  );

export const operationalUnitError = (error, fallback) =>
  error?.response?.data?.message ||
  error?.response?.data?.error?.message ||
  (typeof error?.response?.data?.error === "string"
    ? error.response.data.error
    : null) ||
  error?.message ||
  fallback;
